import { Skeleton } from "@material-ui/lab";
import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReceiptIcon from '@material-ui/icons/Receipt';

export default function Invoices(){
    const {subscription_details} = useSelector(state => state.subscriptionData?.subscriptionData?.original);
    const [invoices, setInvoices] = useState([]);
    const [fetching, setFetching] = useState(false);
    
    const handleFetchInvoices = async () => {
        setFetching(true);
        await Axios.get(`/api/v2/subscriptions/invoices/${subscription_details.subscription_id}`)
        .then((res) => {
            setInvoices(res.data.data);
        })
        .finally(() => {
            setFetching(false)
        });
    };
    
    useEffect(() => {
        handleFetchInvoices();
    }, []);
    
    return(
        <div className="d-flex flex-column">
            <div className="p-5 d-flex flex-row align-items-center">
                <div className="d-flex flex-column">
                    <h1 className="m-0 font-weight-bold">Invoices</h1>
                    <p className="m-0 form-text text-muted pt-2">
                        view your invoices.
                    </p>
                </div>
            </div>
            {fetching && Array(3).fill().map((_, index) => (
                <div key={index} className="mt-3 p-5 d-flex flex-row shadow-sm border rounded align-items-center">
                    <Skeleton variant="rect" width="100%" height={50}/>
                </div>
            ))}
            {!fetching && invoices.map((invoice) => (
                <div className="mt-3 p-5 d-flex flex-row shadow-sm border rounded align-items-center">
                    <div className="col-1">
                        <ReceiptIcon fontSize="large" />
                    </div>
                    <div className="d-flex flex-column justify-content-center">
                        <a href={invoice.hosted_invoice_url} target="_blank" className="h3 m-0 font-weight-bold text-uppercase font-weight-bold">
                            {invoice.number}
                        </a>
                    </div>
                </div>
            ))}
        </div>
    );
};